import { render, staticRenderFns } from "./SchoolSessionsAdd.vue?vue&type=template&id=4949c925"
import script from "./SchoolSessionsAdd.vue?vue&type=script&lang=js"
export * from "./SchoolSessionsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports